/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as artistAdminActions from '../../actions/artistAdminActions';
import ToastrService from '../../services/toastrService';
import * as instrumentActions from '../../actions/instrumentActions';
import urls from '../../constants/urls.js';
import MetaTags from 'react-meta-tags';
import * as browserCheck from '../../utils/browserCheck.js';
import PageLoading from '../common/PageLoading';
import Error from '../common/Error';
import * as qs from 'query-string';
import * as urlUtils from '../../utils/urlUtils';
import ProfileTable from './ProfileTable';
import CreateProfileForm from './CreateProfileForm';

class CreateProfilePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.selectProfile = this.selectProfile.bind(this);
        this.enableDisableProfile = this.enableDisableProfile.bind(this);
        this.updateProfileField = this.updateProfileField.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
        this.getInitialCurrentProfile = this.getInitialCurrentProfile.bind(this);
        this.clearCurrentProfile = this.clearCurrentProfile.bind(this);
        this.onProfileCreated = this.onProfileCreated.bind(this);
        this.state = {
            currentProfile: this.getInitialCurrentProfile()
        };
    }

    componentWillMount() {   

    }

    componentDidMount() {  
        const fromPath = this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname;
        if(fromPath) {
            const toastrService = new ToastrService();
            toastrService.showError('', 'Please create a profile to access this page');
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidUpdate(prevProps, prevState) {
    }

    getInitialCurrentProfile() {
        const user = this.props.user;
        return {
            RoleType: 'Fan',
            Username: this.getUsername(user),
            DisplayName: user ? user.FirstName : '',
            Genres: [],
            City: user ? user.City : '',
            Region: user ? user.Region : '',
            Country: user ? user.Country : '',
            Latitude: user ? user.Latitude : '',
            Longitude: user ? user.Longitude : ''
        };
    }

    getUsername(user) {
        let username = '';
        if(user) {
            username = user.FirstName.toLowerCase();
            if(user.LastName && user.LastName.length) {
                username += user.LastName[0].toLowerCase();
            }
        }
        return username;
    }

    selectProfile(profile) {
        this.setState({
            currentProfile: profile
        });
        this.props.actions.clearCreateProfileError();
    }

    enableDisableProfile(event, id, enable) {
        event.preventDefault();
        this.props.actions.enableDisableProfile(id, enable);
    }

    clearCurrentProfile() {
        this.setState({
            currentProfile: this.getInitialCurrentProfile()
        });
    }

    updateProfileField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-menu__item' ? event.target.innerText : event.target.value;
        const currentProfile = {...this.state.currentProfile};
        currentProfile[name] = value;
        this.setState({ currentProfile });
    }

    updateLocation(location) {
        const currentProfile = {...this.state.currentProfile};
        if(location && location.length) {
            currentProfile['City'] = location[0].city;
            currentProfile['Region'] = location[0].region;
            currentProfile['Country'] = location[0].country;
            currentProfile['Latitude'] = location[0].latitude;
            currentProfile['Longitude'] = location[0].longitude;    
            currentProfile['LocationDesc'] = location[0].label;        
        }
        else {
            currentProfile['City'] = '';
            currentProfile['Region'] = '';
            currentProfile['Country'] = '';
            currentProfile['Latitude'] = '';
            currentProfile['Longitude'] = '';
            currentProfile['LocationDesc'] = ''; 
        }
        this.setState({ currentProfile });
    }

    onProfileCreated() {
        if(this.props.user.Profiles.length === 1) {
            let redirected = false;
            //if it's our 1st profile, redirect to the return url or to the welcome page
            if(this.props.location.search) {
                const params = qs.parse(this.props.location.search);
                if(params && params.returnUrl && !urlUtils.isExternalUrl(params.returnUrl, this.props.location)) {
                    this.props.history.push(params.returnUrl);
                    redirected = true;
                }
            }
            if(!redirected) {
                if(this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname) {
                    this.props.history.push(this.props.location.state.from.pathname);
                }  
                else {          
                    this.props.history.push('/Welcome');
                }
            }
        }        
    }

    render() {   
        return (
            <div id="content">
                <div>
                    <MetaTags>
                        <title>Create Profile - LoudUp</title>
                        <meta id="description" name="description" content="Create a new profile" />
                    </MetaTags>                        
                    <div className="main noclip">
                        <div className="container">
                            <div className="block-inner">
                                <div id="divProfileTable" className="signupbox">
                                    <ProfileTable profiles={this.props.user.Profiles} selectAction={this.selectProfile} enableDisableAction={this.enableDisableProfile} />
                                </div>
                                <h1 className="section-alt">
                                    <div id="divHeaderText">{!this.state.currentProfile.ID ? 'Create a profile' : 'Update your profile'}</div>
                                </h1>                                
                                <div id="divLabels">
                                    {
                                        !this.props.user.Profiles.length ? 
                                            <React.Fragment>
                                                <div id="divInfo" className="alert alert-success" style={{fontWeight: 'normal', lineHeight: '1.3em', textAlign: 'center'}}>
                                                {
                                                    this.props.newSignup ?
                                                        <span style={{fontWeight: 'bold', marginBottom: '10px', display: 'block'}}>Thank you for signing up, your account has been created successfully.</span>              
                                                        : <span>You have logged in successfully.</span>  
                                                }
                                                <strong> Final step</strong>, please create your profile page. You can add more profiles later if you need to!
                                                </div>
                                                <span id="spanNote" style={{fontStyle: 'italic', fontWeight: 'normal', color: '#858585', paddingBottom: '15px', display: 'block'}}>
                                                    Note: You can add more details later, this is just the minimum we need to get started.
                                                </span>
                                            </React.Fragment>
                                        : null
                                    }
                                </div>
                                <div id="divCreateForm">
                                    <CreateProfileForm currentProfile={this.state.currentProfile} updateProfileField={this.updateProfileField} updateLocation={this.updateLocation} clear={this.clearCurrentProfile} onProfileCreated={this.onProfileCreated} displayNarrow />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CreateProfilePage.propTypes = {
    match: PropTypes.object.isRequired,
    artist: PropTypes.object,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object,
    newSignup: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        newSignup: state.account.newSignup,
        genres: state.genres
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistAdminActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfilePage);